/*
 * Botón "Configurar horarios" y su modal: horario de marcación del kiosco por día de la semana (franjas
 * de entrada, almuerzo y salida). Es el mismo comportamiento que tenía la pantalla anterior de
 * Marcaciones, movido aquí sin cambios de lógica: lee y guarda con redux (getAttendanceSchedule /
 * updateAttendanceSchedule, GET y PATCH /attendance/schedule/). El contenedor solo lo muestra con el
 * permiso change_attendanceschedule. Los avisos de guardado (toast) solo salen con el modal abierto.
 * Ojo: este horario es la ventana del kiosco, NO la hora oficial de entrada (08:00, spec 4.2).
 */
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import Button from "../../../../components/button";
import Modal from "../../../../components/modal";
import {getAttendanceSchedule, updateAttendanceSchedule} from "../../../../redux/attendance";

const DIAS_SEMANA = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
const CAMPOS = ['entrada_inicio', 'entrada_fin', 'almuerzo_inicio', 'almuerzo_fin', 'salida_inicio', 'salida_fin'];

const ScheduleModal = ({token}) => {
    const dispatch = useDispatch();
    const _get_attendance_schedule = useSelector((state) => state.attendance_module._get_attendance_schedule);
    const _update_attendance_schedule = useSelector((state) => state.attendance_module._update_attendance_schedule);
    const [show, setShow] = useState(false);
    const [horarios, setHorarios] = useState([]);

    useEffect(() => {
        if (show && _get_attendance_schedule && Array.isArray(_get_attendance_schedule.data)) {
            setHorarios(_get_attendance_schedule.data);
        }
    }, [_get_attendance_schedule, show]);

    useEffect(() => {
        if (!show) return;
        if (_update_attendance_schedule.status === 200) {
            toast.success(_update_attendance_schedule.message);
        } else if (_update_attendance_schedule.status !== 0) {
            toast.error(_update_attendance_schedule.message);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_update_attendance_schedule]);

    function abrir() {
        dispatch(getAttendanceSchedule(token));
        setShow(true);
    }

    function cambiar(dia, campo, valor) {
        setHorarios((prev) => prev.map((h) => (h.dia === dia ? {...h, [campo]: valor || null} : h)));
    }

    function guardar(horario) {
        const {dia, dia_nombre, id, ...campos} = horario;
        dispatch(updateAttendanceSchedule(token, dia, campos));
    }

    return (
        <>
            <Button text="Configurar horarios" onChange={abrir} theme="secondary" classes="btn-sm"/>
            <Modal className="modal-main div-modal1" show={show} auto="900px">
                <h5>Horario de marcación por día</h5>
                <div className="table-responsive mt-2">
                    <table className="table table-bordered">
                        <thead>
                        <tr>
                            <th className="text-center">Día</th>
                            <th className="text-center">Entrada inicio</th>
                            <th className="text-center">Entrada fin</th>
                            <th className="text-center">Almuerzo inicio</th>
                            <th className="text-center">Almuerzo fin</th>
                            <th className="text-center">Salida inicio</th>
                            <th className="text-center">Salida fin</th>
                            <th className="text-center"/>
                        </tr>
                        </thead>
                        <tbody>
                        {horarios.map((h) => (
                            <tr key={h.dia}>
                                <td>{DIAS_SEMANA[h.dia]}</td>
                                {CAMPOS.map((campo) => (
                                    <td key={campo}>
                                        <input type="time" className="form-control form-control-sm"
                                               value={h[campo] ? h[campo].slice(0, 5) : ''}
                                               onChange={(e) => cambiar(h.dia, campo, e.target.value)}/>
                                    </td>
                                ))}
                                <td>
                                    <Button text="Guardar" onChange={() => guardar(h)} theme="success" classes="btn-sm"/>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
                <small className="text-muted">Deja un campo vacío para no habilitar esa marca ese día (por ejemplo, sin
                    almuerzo el sábado, o sin ninguna franja el domingo).</small>
                <div className="mt-3 text-right">
                    <Button text="Cerrar" onChange={() => setShow(false)} theme="dark" classes="btn-sm"/>
                </div>
            </Modal>
        </>
    );
};

export default ScheduleModal;
